import {
  Box,
  Button,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import World from "@mui/icons-material/Public";
import { Info } from "@mui/icons-material";
import { SASButtonStyles } from "../ui/styles/inputStyles";

// tus secciones
const getSections = (isProspect) => [
  {
    name: "General Info",
    description: isProspect ? "Your general prospect information" : "Your general client information",
    icon: <Info fontSize="small" />,
  },
  {
    name: "Locations",
    description: isProspect ? "These are the locations of your prospect" : "These are the locations of your client",
    icon: <World fontSize="small" />,
  },
];

const CustomStepIcon = (props) => {
  const { active, completed, icon, isProspect } = props;

  const ORANGE = "#FB8E00";
  const GRAY = "#C2C2C2";
  const sections = getSections(isProspect);

  return (
    <Box
      sx={{
        width: 28,
        height: 28,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "1rem",
        fontWeight: 600,
        backgroundColor: active || completed ? ORANGE : "#fff",
        border: `2px solid ${active || completed ? ORANGE : GRAY}`,
        color: active || completed ? "#fff" : GRAY,
        transition: "all 0.2s ease-in-out",
      }}
    >
      {sections[icon - 1]?.icon || icon}
    </Box>
  );
};

export const ClientCreateStepper = ({ activeStep, onBack, hasCoverageAreas, isProspect = false }) => {
  const sections = getSections(isProspect);

  return (
    <Stepper
      activeStep={activeStep}
      orientation="vertical"
      sx={{ zIndex: 99, width: "70%" }}
    >
      {sections.map((section, index) => (
        <Step key={index}>
          <StepLabel StepIconComponent={(props) => <CustomStepIcon {...props} isProspect={isProspect} />}>
            {section.name}
          </StepLabel>
          <StepContent sx={{ width: "80%" }}>
            <Typography sx={{ mb: 2 }}>{section.description}</Typography>

            {/* Continue */}
            <Button
              type="submit"
              form="client-form-general-info"
              size="small"
              sx={{
                display: index === 1 ? "none" : "block",
                ...SASButtonStyles,
              }}
            >
              Continue
            </Button>

            {/* Back */}
            <Button
              size="small"
              disabled={index === 0}
              onClick={onBack}
              sx={{ mt: 1, mr: 1, ...SASButtonStyles }}
            >
              Back
            </Button>


            <Button
              type="submit"
              form="client-form-coverage-areas"
              size="small"
              sx={{ ...SASButtonStyles, display: index === 1 ? "block" : "none", mt: 2 }}
              disabled={!hasCoverageAreas}
            >
              Finish
            </Button>

          </StepContent>
        </Step>
      ))}
    </Stepper>
  );
};
